module.exports = __webpack_public_path__ + "img/12.304ba750.jpeg";